// libs
import React, { memo, useContext } from "react";

// Components
import Image from "shared/components/Image";

// Helper
import { getAkamaiUrl } from "shared/helpers/utils";
import { generateTrackingUrlForMegaMenu } from "shared/components/Header/helpers";

// Context
import MenuContext from "shared/components/Header/DesktopHeader/components/Menu/MenuContext";

// styles
import { Wrapper, ImageContainer } from "./styles";
import { IMapOfString } from "global";

const IMAGE_WIDTH = 162;

// defs
interface ITopCategoriesProps {
    data: any;
}

function TopCategories({ data }: ITopCategoriesProps) {
    const { goToUrl } = useContext(MenuContext);

    const onClick = (e: React.MouseEvent, subSectionData: IMapOfString) => {
        e.preventDefault();
        goToUrl(subSectionData);
    };

    return (
        <Wrapper>
            <div className="title">{data.title}</div>
            <div className="images">
                {data.children.map((childData: any, idx: number) => {
                    const child = { ...childData, position: idx + 1 };
                    return (
                        <ImageContainer
                            href={generateTrackingUrlForMegaMenu(child)}
                            key={idx}
                            className="imgCnt"
                            onClick={e => onClick(e, child)}
                            aria-label={child.title}
                            as="a"
                        >
                            <Image
                                className="img"
                                imgClassName="img"
                                src={getAkamaiUrl(child.image_url, { width: IMAGE_WIDTH * 2 })}
                                alt={child.title}
                                width={IMAGE_WIDTH}
                                aspectRatio={child.aspect_ratio}
                            />
                            <div className="label">{child.title}</div>
                        </ImageContainer>
                    );
                })}
            </div>
        </Wrapper>
    );
}

export default memo(TopCategories);
